import { render, staticRenderFns } from "./Precise.vue?vue&type=template&id=55fb49a1&scoped=true&"
import script from "./Precise.vue?vue&type=script&lang=js&"
export * from "./Precise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55fb49a1",
  null
  
)

export default component.exports